const removeTabContent = () => {
  const tabNav = document.querySelector('#js__app__tabs__nav');
  const tabWrapper = tabNav ? tabNav.parentNode : null;

  if (tabWrapper) tabWrapper.parentNode.removeChild(tabWrapper);
};

const parseBreadCrumbData = () => {
  const breadCrumbsEls = [...document.getElementsByClassName('js__g__breadcrumbs__item')];

  return breadCrumbsEls.map((item) => ({
    title: item.textContent,
    url: item.getElementsByTagName('a')[0].href,
  }));
};

const parseDevicesTabTitle = () => {
  const devicesTabEl = document.querySelector('#js__tabs__nav__compatibility .js__app__tabs__list__tab');

  return devicesTabEl.textContent;
};

const parseEmsData = () => {
  const emsGroups = [...document.getElementsByClassName('app__product__filters__group')];
  const optionSelect = document.querySelector('#js__products__select');

  // If we have a dropdown return the labels for it
  if (optionSelect) {
    return [{
      title: document.querySelector('.app__product__filters__label').textContent,
    }];
  }

  return emsGroups.map((group, i) => {
    // get options data
    const optionEls = [...group.getElementsByClassName('js__filter-option')];

    if (!optionEls.length) return [];

    const optionDefault = optionEls[0];
    const { dataset } = optionDefault;
    const id = dataset.optionid;
    const options = optionEls.map((op, j) => {
      const { href, textContent } = op;
      const { option, sku, optionid } = op.dataset;
      const image = op.getElementsByTagName('img')[0];

      return {
        order: j,
        id: option.replace(`${optionid}-`, ''),
        text: textContent,
        url: href,
        sku,
        image: image ? image.src : undefined,
        altText: image ? image.alt : undefined,
      };
    });

    // get tooltip data
    const tooltipEl = group.getElementsByClassName('g__tooltip')[0];
    const summaryEl = tooltipEl ? tooltipEl.getElementsByClassName('g__tooltip__summary')[0] : [];
    const labelEl = group.getElementsByClassName('app__product__filters__label')[0];
    const title = tooltipEl ? summaryEl.getElementsByTagName('span')[0].textContent : labelEl.getElementsByTagName('p')[0].textContent;
    // The tooltip text may be in the first, second or n-th p tag. Nothing is certain.
    // We just filter all p tags and combined all nodes in tooltip into one tooltip string.
    const tooltipContainer = tooltipEl ? [...tooltipEl.querySelectorAll('p')].filter((node) => node.textContent) : [];
    const tooltip = tooltipEl ? tooltipContainer.reduce((string, tooltipNode) => string + tooltipNode.outerHTML, '') : '';

    return {
      id,
      order: i,
      type: id === 'enableFilterImage' ? 'image' : 'ems',
      title,
      tooltip,
      options,
    };
  });
};

const parseFilterDropdownData = () => {
  const defaultOps = [];
  const optionSelect = document.querySelector('#js__products__select');
  if (!optionSelect) return defaultOps;

  const optionEls = [...optionSelect.getElementsByTagName('option')];
  if (!optionEls.length) return defaultOps;

  return optionEls.map((option) => ({
    text: option.textContent,
    value: option.value,
    selected: option.selected,
  }));
};

export const parseSidebarCustomLinks = (htmlString) => {
  if (typeof htmlString !== 'string') return htmlString;

  const html = document.createElement('div');
  html.innerHTML = htmlString;
  const sideBarLinks = [...html.getElementsByTagName('a')];

  return sideBarLinks.map((link) => ({
    text: link.textContent,
    url: link.href,
  }));
};

export const parsePpgHtml = () => {
  const breadCrumbs = parseBreadCrumbData();
  const productEmsList = parseEmsData();
  const filterDropdownList = parseFilterDropdownData();
  const devicesTabTitle = parseDevicesTabTitle();

  removeTabContent();

  return {
    breadCrumbs,
    productEmsList,
    filterDropdownList,
    devicesTabTitle,
  };
};

export default parsePpgHtml;
